<template>
  <div>
    <b-row>
      <b-col>
        <md-field :class="{'md-invalid': emailErr}" class="moow-input">
          <label>Email</label>
          <md-input v-model="username"></md-input>
          <span class="md-error">{{emailErr}}</span>
        </md-field>
        <md-field :class="{'md-invalid': passwordErr}" class="moow-input">
          <label>Password</label>
          <md-input v-model="password" type="password"></md-input>
          <span class="md-error">{{passwordErr}}</span>
        </md-field>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col class="text-right text-info">
        <a href="#" style="color:black" v-b-modal.reset-password>Forgot password?</a>
      </b-col>
    </b-row>
    <b-modal id="reset-password" ref="resetPassModal" title="Reset password" @ok="resetPassword">
      <b-form @submit="resetPassword">
        <b-row class="mb-2">
          <b-col>
            <b-form-group breakpoint="lg" class="mb-0">
              <b-form-input class="mb-3" v-model="resetEmail" placeholder="Email"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-row>
      <moow-button :type="['light', 'wide']" btnText="Log In" @mClick="login()" />
    </b-row>
    <!--Identity Provider Sign-In:-->
    <!--<b-row class="mt-3">
      <b-col class="text-center">
        <md-divider></md-divider>
        <p>OR</p>
        &lt;!&ndash; <span
          style="background-color:white;position:absolute;left:42%;padding-left:10px;padding-right:10px"
          class="text-center"
        >or</span>
        <span class="line" style="position:static"></span>&ndash;&gt;
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-2" style="text-align:center">
        <md-button class="md-icon-button md-raised" @click="googleSignIn">
          <md-icon>
            <img src="../../assets/btn_googl_fab.png" alt="Google" />
          </md-icon>
        </md-button>
      </b-col>
    </b-row>-->
    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-accent" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>
<script>
import firebaseTranslator from "@/third-party/firebase/config/firebaseConfig.json";
import { loginAuthUserWithEmailAndPassword } from "@/platform/auth/services/authService.js";

export default {
  name: "loginForm",
  props: {},
  data() {
    return {
      showSnackbar: false,
      snackbarMessage: "",
      username: "",
      password: "",
      loading: false,
      resetEmail: "",
      emailErr: "",
      passwordErr: "",
      rules: {
        emailRule: /.+@.+/,
      },
    };
  },
  watch: {
    username: function (val, oldVal) {
      if (val && val != oldVal) {
        if (this.rules.emailRule.test(val)) this.emailErr = "";
        else this.emailErr = "Invalid email";
      } else this.emailErr = "Required";
    },
    password: function (val, oldVal) {
      if (val) this.passwordErr = "";
      else this.passwordErr = "Required";
    },
  },
  mounted() {
    document.addEventListener("keyup", this.keyPressAction);
  },
  beforeUnmount(){
    this.username = "";
    this.password = "";
  },
  methods: {
    keyPressAction(keyCode) {
      switch (keyCode.code) {
        case "Enter":
          this.login();
          break;
      }
    },
    login() {
      if (!this.validateForm()) return;
      this.$emit("emitLoading", true);

      // FYI: this cannot be async due to emitting logic
      loginAuthUserWithEmailAndPassword({email: this.username, password: this.password})
        .then(userCredentials => {
          if (!userCredentials.user.emailVerified) this.notifyUser("Verify Email", "Link sent to email");
          this.$emit("emitSuccessfulLogin");
        })
        .catch(err => {
          this.$emit("emitFailedLogin", err);
          this.showFailure(err);
        }).finally(f =>{
          this.password = "";
        })
    },
    validateForm() {
      var res = true;
      if (!this.password) {
        res = false;
        this.passwordErr = "Required";
      }
      if (!this.username || !this.rules.emailRule.test(this.username)) {
        res = false;
        this.emailErr = "Invalid";
      }
      return res;
    },
    googleSignIn() {
      let provider = new firebase.auth.GoogleAuthProvider();
      this.$emit("emitLoading", true);
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          this.$emit("emitSuccessfulLogin");
        })
        .catch((err) => {
          this.showFailure(err);
          this.$emit("emitFailedLogin", err);
        });
    },
    showFailure(error) {
      error.code
        ? (this.snackbarMessage =
            firebaseTranslator.responseCodeToFriendlyMessageMap[error.code])
        : void 0;
      !this.snackbarMessage
        ? (this.snackbarMessage = "Something is not right")
        : void 0;
      this.showSnackbar = true;
    },
    resetPassword(e) {
      firebase
        .auth()
        .sendPasswordResetEmail(this.resetEmail)
        .then((res) => {
          this.$refs.resetPassModal.hide();
          this.$notify({
            title: "Check your email",
            message: "Reset link sent",
          });
        })
        .catch((error) => {
          this.$refs.resetPassModal.hide();
          this.loading = false;
          var errorCode = error.code;
          var errorMessage = error.message;
          this.$notify({
            title: "Notification",
            message: errorMessage,
          });
        });
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/global.css";

.line {
  display: inline-block;
  vertical-align: middle;
  zoom: 1;
  width: 100%;
  border: 1px solid #ededed;
}

.text-info {
  color: grey;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/loginForm.vue